import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  // Start with 30 minutes (1800 seconds) for urgency
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(1800);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <div className="sticky top-0 z-50 w-full bg-gradient-to-r from-amber-600 to-yellow-500 text-white shadow-lg" data-id="element-182">
      <div className="max-w-7xl mx-auto px-4 py-3 flex flex-col sm:flex-row items-center justify-between gap-2 text-sm font-medium" data-id="element-183">
        <div className="flex items-center gap-2" data-id="element-184">
          <span className="relative flex h-3 w-3" data-id="element-185">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-400 opacity-75" data-id="element-186"></span>
            <span className="relative inline-flex rounded-full h-3 w-3 bg-red-600" data-id="element-187"></span>
          </span>
          <span className="uppercase tracking-wide font-bold text-xs sm:text-sm" data-id="element-188">
            Oferta activa: bonus incluidos HOY
          </span>
        </div>

        <div className="flex items-center gap-2 bg-black/20 px-3 py-1 rounded-full backdrop-blur-sm" data-id="element-189">
          <span data-id="element-190">Termina en:</span>
          <span className="font-mono font-bold text-lg" data-id="element-191">
            {formatTime(minutes)}:{formatTime(seconds)}
          </span>
        </div>
      </div>
    </div>;
}